export class ExecuetAppRequest {
    exeName?: string;
    downloadUrl?: string;
    parameters?: string[];
    forceDownload?: boolean;
    execute?: boolean;
}